import React, { memo } from 'react';
import { Select, SelectProps, Space, Typography } from 'antd';
import { COLORS, i18n } from 'core';
import { createUseStyles } from 'react-jss';
const { Text } = Typography;
interface Props extends SelectProps {
  label?: string;
  options?: any[];
  onChange?:any
}

const useStyles = createUseStyles<string, unknown, COLORS>(
  (colors) => ({
    root: {},
  })
);
const SelectBox = memo<Props>(({onChange, label, options, ...rest }) => {
  const classes = useStyles();
  return (
    <Space
      className={classes.root}
      direction="vertical"
      style={{ display: 'block' }}
    >
      {Boolean(label) && <Text>{label}:</Text>}
       <Select
      options={options}
      onChange={onChange}
      showSearch
      placeholder={i18n.t('enterValueOrSelectValue')}
      style={{ flex: 1, display: 'block' }}
      optionFilterProp="children"
      filterOption={(input, option) =>
        String(option?.label || '').includes(input)
      }
      filterSort={(optionA, optionB) =>
        String(optionA?.label ?? '')
          .toLowerCase()
          .localeCompare(String(optionB?.label ?? '').toLowerCase())
      }
      {...rest}
    />
    </Space>
  );
});

export { SelectBox };
